import React from 'react'
import { ComponentExt } from 'util/reactExt'
import FBForm from '../../shared/FeedbackForm'
import styles from './index.scss'

enum EStatus {
  feedone = '3000101',
  failture = '3000102',
  success = '3000103',
  backdone = '3000104',
}

interface State {
  categories: any[]
  historyList: any[]
  total: number
  page: number
}

class Feedback extends ComponentExt<{}, State> {
  constructor(props) {
    super(props)
    this.state = {
      categories: [],
      historyList: [],
      total: 0,
      page: 1,
    }
  }

  componentDidMount() {
    this.fetchCategory()
  }

  async fetchCategory() {
    try {
      const data = await this.api.feedback.getFeedbackCategory()
      this.setState({ categories: data })
    } catch (err) {
      console.error(err.message)
    }
  }

  handleFinishPost = () => {}

  handleFeedback = async (id, idx) => {
    const status = [EStatus.failture, EStatus.success][idx]
    try {
      await this.api.feedback.updateFeedbackState(id, status)
    } catch (err) {
      console.error(err.message)
    }
  }

  render() {
    const { categories } = this.state

    // const bcData = [{ name: '首页', url: '/' }, { name: '反馈中心', url: '' }]
    return (
      <div className={styles.feedback}>
        <div className={styles.feedbackInner}>
          {/* <Breadcrumb data={bcData} /> */}
          <FBForm category={categories} callback={this.handleFinishPost} />
        </div>
      </div>
    )
  }
}

export default Feedback
